import React from "react";

const Databases = () => {
  return <div>Databases</div>;
};

export default Databases;
